(function () {
  const unlockVerticalScroll = (scroller) => {
    if (!scroller || scroller.dataset.scrollUnlock === 'true') return;
    scroller.dataset.scrollUnlock = 'true';

    let startX = 0;
    let startY = 0;
    let axis = '';

    scroller.addEventListener(
      'touchstart',
      (event) => {
        const touch = event.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        axis = '';
        scroller.style.overflowX = '';
      },
      { passive: true }
    );

    scroller.addEventListener(
      'touchmove',
      (event) => {
        if (axis || !event.touches[0]) return;

        const dx = Math.abs(event.touches[0].clientX - startX);
        const dy = Math.abs(event.touches[0].clientY - startY);
        if (dx < 8 && dy < 8) return;

        axis = dy > dx ? 'y' : 'x';
        if (axis === 'y') {
          scroller.style.overflowX = 'hidden';
        }
      },
      { passive: true }
    );

    const reset = () => {
      scroller.style.overflowX = '';
      axis = '';
    };

    scroller.addEventListener('touchend', reset, { passive: true });
    scroller.addEventListener('touchcancel', reset, { passive: true });
  };

  const init = (scope = document) => {
    scope
      .querySelectorAll('.collab-article-others__grid')
      .forEach(unlockVerticalScroll);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
